import { render, staticRenderFns } from "./ZapisnikIPPDF.vue?vue&type=template&id=314d4a9a&scoped=true&"
import script from "./ZapisnikIPPDF.vue?vue&type=script&lang=js&"
export * from "./ZapisnikIPPDF.vue?vue&type=script&lang=js&"
import style0 from "./ZapisnikIPPDF.vue?vue&type=style&index=0&id=314d4a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314d4a9a",
  null
  
)

export default component.exports